export default function getChargeCredits(
  amount: number,
) {
  let num = 0;
  if (amount <= 2000) {
    num = 4;
  } else if (amount <= 5000) {
    num = 4.5;
  } else if (amount <= 30000) {
    num = 5;
  } else {
    num = 5.5;
  }
  return (amount * num) / 100;
}
